import { createSelector } from 'reselect';

import IState from 'types/Istore';

export const tradingViewChartSelector = (state: IState) => state.tradingView;

export const markPriceChartSelector = createSelector(
  [tradingViewChartSelector],
  tv => tv.markPriceChart
);

export const shouldShowClosePositionPopupSelector = createSelector(
  [tradingViewChartSelector],
  tv => tv.shouldShowClosePositionPopup
);

export const chartActiveTabSelector = createSelector(
  [tradingViewChartSelector],
  tv => tv.activeTab
);

export const isChartFrozenSelector = createSelector(
  [tradingViewChartSelector],
  tv => tv.isChartFrozen
);

export const showPlaceOrderSectionSelector = createSelector(
  [tradingViewChartSelector],
  tv => tv.showPlaceOrderSection
);

export const chartCountSelector = createSelector(
  [tradingViewChartSelector],
  tv => tv.chartCount
);

export const futuresChartCountSelector = createSelector(
  [chartCountSelector],
  chartCount => chartCount.futures
);

export const optionsChartCountSelector = createSelector(
  [chartCountSelector],
  chartCount => chartCount.options
);

export const trackerChartCountSelector = createSelector(
  [chartCountSelector],
  chartCount => chartCount.tracker
);

export const defaultChartCountSelector = createSelector(
  [chartCountSelector],
  chartCount => chartCount.default
);
